"use client";
import * as React from "react";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="mt-20 max-md:mt-6 max-md:max-w-full max-md:px-2">
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
        {/* Left: Content */}
        <div className="w-[90%] max-md:w-full max-md:mx-auto max-md:mb-0 flex flex-col items-start max-md:items-start">
          <div className="flex flex-col mt-24 w-full max-md:mt-0 max-md:max-w-full">
            {/* SVG Heading */}
            <div className="overflow-x-auto max-w-full flex justify-start max-md:justify-start">
              <div
                dangerouslySetInnerHTML={{
                  __html: `
<svg width="100%" height="39" viewBox="0 0 560 39" fill="none" xmlns="http://www.w3.org/2000/svg" class="header-icon" style="min-width:240px;max-width:100%;">
  <circle cx="16" cy="19.5" r="16" fill="url(#paint0_linear)" />
  <circle cx="16" cy="19.5" r="8" fill="#473256" />
  <text fill="url(#paint1_linear)" xml:space="preserve" style="white-space: pre" font-family="Inter" font-size="clamp(18px,5vw,32px)" font-weight="500" letter-spacing="0em">
    <tspan x="42" y="31.1364">Welcome to Baby Unicorn AI</tspan>
  </text>
  <defs>
    <linearGradient id="paint0_linear" x1="6.46305" y1="11.7963" x2="30.555" y2="11.7963" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
    <linearGradient id="paint1_linear" x1="125.414" y1="10.1111" x2="536.351" y2="10.1111" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFA8D1" />
      <stop offset="0.475962" stop-color="#C3B1FF" />
      <stop offset="1" stop-color="#AEE2FF" />
    </linearGradient>
  </defs>
</svg>
`,
                }}
              />
            </div>

            {/* Main Heading */}
            <h1 className="mt-6 text-5xl font-extrabold tracking-wider text-white leading-[52px] font-fredoka max-md:text-left max-md:text-3xl max-md:leading-9">
              Where Magic
              <br />
              Meets{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
                Technology
              </span>
            </h1>

            {/* Subtitle */}
            <div className="mt-12 w-full text-neutral-100 max-md:mt-6 max-md:text-left">
              <h3 className="text-3xl font-semibold leading-none text-white max-md:text-lg max-md:font-bold">
                The Future of Play, Learning, and Imagination Starts Here
              </h3>
              <p className="mt-4 text-2xl leading-8 max-md:text-base max-md:leading-5">
                At Baby Unicorn, we're creating something truly special — a magical world where wonder, friendship, and intelligent play come together
              </p>
            </div>

            {/* Buttons and Socials */}
       {/* Buttons and Socials */}
<div className="flex flex-wrap gap-6 items-center mt-12 max-md:mt-6 w-full max-md:flex-col max-md:items-center">
  
  {/* Left side buttons */}
  <div className="flex flex-wrap gap-6 max-md:flex-col max-md:items-center">
    <Link
      to="https://babyu-sale.tech/"
      className="relative z-10 btn-glow-gradient flex justify-center items-center gap-2.5 px-8 py-5 text-2xl font-semibold tracking-wide text-white border-2 border-white bg-[linear-gradient(90deg,#FF6EB3_0%,#AA81FF_47.12%,#6BC9FF_100%)] shadow-[0px_4px_16px_#ff49b8] min-h-16 min-w-60 rounded-[50px] max-md:w-full max-md:text-base transition-all duration-200"
    >
      <span>Join Presale</span>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/8490b493579621a21a9806eb89a7ed0f66e15b73"
        className="object-contain w-[25px] max-md:w-5"
        alt="Arrow icon"
      />
    </Link>

    <Link     to="/ToySection" className="flex gap-2.5 justify-center items-center px-8 py-5 text-2xl font-semibold tracking-wide  border border-solid border-white min-h-16 rounded-[50px] max-md:w-full max-md:text-base">
      <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FFA8D1] via-[#C3B1FF] to-[#AEE2FF]">
      Preorder Unicorn AI toy
      </span>
    </Link>
  </div>

  {/* Right side social icons */}
  <div className="flex gap-4 items-center max-md:justify-center">
    <a href="https://t.me/BabyUnicornAI" target="_blank" rel="noopener noreferrer">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/b6d2af109b7c028a21759919d659128dec64a94b"
        alt="Telegram"
        className="w-10 h-10 p-1 rounded border border-pink-300 hover:opacity-80 transition-opacity"
      />
    </a>

    <a href="https://x.com" target="_blank" rel="noopener noreferrer">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/6fa8edb2161dfbd8e6afbb6cc7ececea7de14008"
        alt="Twitter/X"
        className="w-10 h-10 p-1 rounded border border-pink-300 hover:opacity-80 transition-opacity"
      />
    </a>
  </div>
</div>





          </div>
        </div>
        {/* Right: Image */}
        <div className="ml-5 w-[43%] max-md:ml-0 max-md:w-full max-md:mt-6 flex justify-start">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/1af45cfc6296186df7258a28420535596f1de4cf?placeholderIfAbsent=true&apiKey=0c11d46dd7d64d7a84bf3e17dbee5689"
            className="object-contain w-full rounded-none aspect-[0.95] max-md:mt-4 max-md:max-w-full"
            alt="Baby Unicorn illustration"
          />
        </div>
      </div>
    </section>
  );
};
